<template>
  <v-form ref="formRef" class="px-4 pt-2">
    <v-row v-for="(owner, index) in localValue" :key="index" no-gutters>
      <v-col cols="3">
        <h4 class="mb-2">
          Anrede<sup v-if="mandatory" class="required">*</sup>
        </h4>
        <v-radio-group
          v-model="owner.salutation"
          :rules="mandatory"
          class="mt-3"
          inline
          density="compact"
        >
          <v-radio label="Frau" value="Frau" />
          <v-radio label="Herr" value="Herr" class="ml-2" />
        </v-radio-group>
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="owner.firstName"
          label="Vorname"
          :rules="mandatory"
          density="compact"
          variant="underlined"
          class="mt-5"
        >
          <template #label>
            Vorname <sup v-if="mandatory" class="required">*</sup>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="5">
        <v-text-field
          v-model="owner.lastName"
          class="ml-3 mt-5"
          label="Nachname"
          :rules="mandatory"
          append-icon="mdi-delete"
          density="compact"
          variant="underlined"
          @click:append="localValue.splice(index, 1)"
        >
          <template #label>
            Nachname <sup v-if="mandatory" class="required">*</sup>
          </template>
        </v-text-field>
      </v-col>
    </v-row>
    <v-btn
      v-if="localValue.length < 5"
      variant="tonal"
      prepend-icon="mdi-plus-thick"
      class="mt-4"
      @click="addNewLine"
    >
      Weitere Anschlussinhaber hinzufügen
    </v-btn>
  </v-form>
</template>
<script setup lang="ts">
import { computed, ref } from 'vue';
import { mandatory } from '../../composables/validations';
import type { Household } from '../../types/household';

const modelValue = defineModel<Household[]>({ required: true });

const formRef = ref();

const localValue = computed<Household[]>({
  get: () => modelValue.value,
  set: value => {
    modelValue.value = value;
  },
});

async function addNewLine() {
  const { valid } = await formRef.value.validate();
  if (!valid) {
    return;
  }

  localValue.value.push({ salutation: '', firstName: '', lastName: '' });
}

if (localValue.value.length === 0) {
  localValue.value.push({ salutation: '', firstName: '', lastName: '' });
}
</script>
